export { default } from './EventImage';
